const RETIRED_INVITE_NOTICE_KEY = "cc_legacy_invite_retired_notice";

function queryContainsInvite(url) {
  if (url.searchParams.has("invite")) return true;
  const hashQuery = url.hash.includes("?") ? url.hash.split("?").slice(1).join("?") : "";
  return new URLSearchParams(hashQuery).has("invite");
}

export function retiredInviteNoticeRequired() {
  try {
    const url = new URL(window.location.href);
    if (queryContainsInvite(url)) {
      window.sessionStorage.setItem(RETIRED_INVITE_NOTICE_KEY, "notice");
      return true;
    }
    return window.sessionStorage.getItem(RETIRED_INVITE_NOTICE_KEY) === "notice";
  } catch {
    return false;
  }
}

export function retiredInviteLoginRequired() {
  try {
    retiredInviteNoticeRequired();
    return window.sessionStorage.getItem(RETIRED_INVITE_NOTICE_KEY) !== null;
  } catch {
    return false;
  }
}

export function showNormalSignInFromRetiredInvite() {
  try { window.sessionStorage.setItem(RETIRED_INVITE_NOTICE_KEY, "signin"); } catch { /* no-op */ }
}

export function removeRetiredInviteFromUrl() {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete("invite");
    if (url.hash.includes("?")) {
      const [hashPath, hashQuery] = url.hash.split("?", 2);
      const params = new URLSearchParams(hashQuery);
      params.delete("invite");
      url.hash = params.toString() ? `${hashPath}?${params}` : hashPath;
    }
    window.history.replaceState({}, "", url.toString());
  } catch { /* URL history unavailable */ }
}

export function clearRetiredInviteNotice() {
  try { window.sessionStorage.removeItem(RETIRED_INVITE_NOTICE_KEY); } catch { /* no-op */ }
}